import { c as _c } from "react/compiler-runtime";
import React, { FC, ReactNode } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { BoxIcon } from '@systemeio/ui/icons';
type Props = {
  additionalChild?: ReactNode;
};
export const DigitalProductBase: FC<Props> = t0 => {
  const $ = _c(15);
  const {
    additionalChild
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BoxIcon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("dashboard.funnel.configuration.offer.digital_product");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="text-brand-primary flex flex-row items-center gap-1 text-sm lg:text-[15px]">{t1}<span>{t2}</span></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== additionalChild || $[6] !== t3) {
    t4 = <div className="flex items-center justify-between">{t3}{additionalChild}</div>;
    $[5] = additionalChild;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("dashboard.funnel.configuration.offer.digital_product_description");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="text-sm font-normal">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="flex flex-col gap-3">{t4}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};